module.exports = __webpack_public_path__ + "static/media/SquaresWhite.90c90a08.svg";